import React from 'react';
import { IconButton, Typography } from '@mui/material';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import { useTranslation } from 'react-i18next';
import { FONT_FAMILY } from 'common/sharedFunctions';
import { useThemeMode } from './Theme/ThemeModeContext';
import { colors } from './Theme/WebTheme';

const GoBackButton = ({ isRTL, onClick, style }) => {
  const { t } = useTranslation();
  const themeModeContext = useThemeMode();
  const themeMode = themeModeContext && themeModeContext.themeMode ? themeModeContext.themeMode : 'system';
  const cardColors = {
    light: { icon: colors.BLACK, text: colors.BLACK, bg: colors.WHITE, hover: '#f0f0f0' },
    dark: { icon: colors.WHITE, text: colors.WHITE, bg: '#23263A', hover: '#181A20' },
    system: { icon: colors.BLACK, text: colors.BLACK, bg: colors.WHITE, hover: '#f0f0f0' },
  };
  const palette = cardColors[themeMode] || cardColors.light;

  return (
    <div dir={isRTL === "rtl" ? "rtl" : "ltr"} style={{ ...style }}>
      <IconButton
        onClick={onClick}
        sx={{
          color: palette.icon,
          backgroundColor: palette.bg,
          borderRadius: 2,
          p: 1,
          boxShadow: 1,
          transition: 'background 0.2s',
          '&:hover': {
            backgroundColor: palette.hover,
            color: palette.text,
          },
        }}
        aria-label={t('go_back')}
      >
        {isRTL === "rtl" ? <ArrowForwardIosIcon /> : <ArrowBackIosNewIcon />}
        <Typography
          sx={{
            ml: isRTL === "rtl" ? 0 : 1,
            mr: isRTL === "rtl" ? 1 : 0,
            fontWeight: 'bold',
            fontFamily: FONT_FAMILY,
            color: palette.text,
            fontSize: 16,
            textAlign: isRTL === "rtl" ? "right" : "left",
          }}
        >
          {t('go_back')}
        </Typography>
      </IconButton>
    </div>
  );
};

export default GoBackButton;